// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"9200572f","298":"f599861c","488":"9ae6de3b","888":"7ab81f1d"}[chunkId] + ".chunk.js";
};